// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1UPjg","consentsList":"PatientConsents_consentsList__3jhWa","consentsListEmpty":"PatientConsents_consentsListEmpty__SSqRO"};